import { RouteObject, Navigate } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const PrecosPage = lazy(() => import('../pages/precos/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const PlanSelectionPage = lazy(() => import('../pages/planos/selection'));
const LegalDocumentPage = lazy(() => import('../pages/legal/DocumentPage'));
const AceiteTermosPage = lazy(() => import('../pages/legal/AceiteTermosPage'));
const AdminJuridicoPage = lazy(() => import('../pages/admin/juridico/page'));
const AdminNovidadesPage = lazy(() => import('../pages/admin/novidades/page'));
const TrialVouchersPage = lazy(() => import('../pages/admin/vouchers/page'));
const AdminClientesPage = lazy(() => import('../pages/admin/clientes/page'));
const AdminClienteDetalhesPage = lazy(() => import('../pages/admin/clientes/detalhes/page'));
const AdminWhatsappPoolPage = lazy(() => import('../pages/admin/whatsapp/page'));
const AdminPlanosPage = lazy(() => import('../pages/admin/planos/page'));
const AdminAlteracoesPage = lazy(() => import('../pages/admin/alteracoes/page'));
const AdminAdministradoresPage = lazy(() => import('../pages/admin/administradores/page'));
const AdminComercialPage = lazy(() => import('../pages/admin/comercial/page'));
const AdminRepresentantePage = lazy(() => import('../pages/admin/comercial/representante/page'));
const AdminVendedoresPage = lazy(() => import('../pages/admin/comercial/vendedores/page'));
const AdminComercialClientesPage = lazy(() => import('../pages/admin/comercial/clientes/page'));
const AdminComercialFinanceiroPage = lazy(() => import('../pages/admin/comercial/financeiro/page'));
const PortalDashboardPage = lazy(() => import('../pages/portal/page'));
const PortalVouchersPage = lazy(() => import('../pages/portal/vouchers/page'));
const PortalClientesPage = lazy(() => import('../pages/portal/clientes/page'));
const PortalEquipePage = lazy(() => import('../pages/portal/equipe/page'));
const PortalComissoesPage = lazy(() => import('../pages/portal/comissoes/page'));
const PortalPerfilPage = lazy(() => import('../pages/portal/perfil/page'));
const EsqueciSenhaPage = lazy(() => import('../pages/login/EsqueciSenhaPage'));
const RedefinirSenhaPage = lazy(() => import('../pages/login/RedefinirSenhaPage'));

const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ClientesPage = lazy(() => import('../pages/cadastros/clientes/page'));
const ClienteCentralPage = lazy(() => import('../pages/cadastros/clientes/central/page'));
const FornecedoresPage = lazy(() => import('../pages/cadastros/fornecedores/page'));
const ServicosPage = lazy(() => import('../pages/cadastros/servicos/page'));
const ProdutosPage = lazy(() => import('../pages/estoque/produtos/page'));
const EntradasPage = lazy(() => import('../pages/estoque/entradas/page'));
const SaidasPage = lazy(() => import('../pages/estoque/saidas/page'));
const EstoqueDashboardPage = lazy(() => import('../pages/estoque/dashboard/page'));
const AjustesEstoquePage = lazy(() => import('../pages/estoque/ajustes/page'));
const ProducaoPage = lazy(() => import('../pages/estoque/producao/page'));
const FechamentoFiscalPage = lazy(() => import('../pages/fiscal/fechamento/page'));
const NotasFiscaisPage = lazy(() => import('../pages/fiscal/notas/page'));
const InvoicesPage = lazy(() => import('../pages/fiscal/invoices/page'));
const ExportacaoRelatoriosPage = lazy(() => import('../pages/fiscal/exportacao/page'));
const InvoiceDetalhePage = lazy(() => import('../pages/fiscal/invoices/detalhes/page'));
const DevolucaoPage = lazy(() => import('../pages/estoque/devolucao/page'));
const ContasPagarPage = lazy(() => import('../pages/financeiro/contas-pagar/page'));
const ContasReceberPage = lazy(() => import('../pages/financeiro/contas-receber/page'));
const FluxoCaixaPage = lazy(() => import('../pages/financeiro/fluxo-caixa/page'));
const FinanceiroDashboardPage = lazy(() => import('../pages/financeiro/dashboard/page'));
const ContasBancariasPage = lazy(() => import('../pages/financeiro/contas-bancarias/page'));
const ConciliacaoBancariaPage = lazy(() => import('../pages/financeiro/conciliacao/page'));
const CobrancaPage = lazy(() => import('../pages/financeiro/cobranca/page'));
const PerdasFinanceirasPage = lazy(() => import('../pages/financeiro/perdas/page'));
const DrePage = lazy(() => import('../pages/financeiro/dre/page'));
const PerdasEstoquePage = lazy(() => import('../pages/estoque/perdas/page'));
const VendasPage = lazy(() => import('../pages/vendas/vendas/page'));
const ExpedicaoPage = lazy(() => import('../pages/vendas/expedicao/page'));
const NovaVendaPage = lazy(() => import('../pages/vendas/nova-venda/page'));
const NovaVendaB2BPage = lazy(() => import('../pages/vendas/nova-venda-b2b/page'));
const PDVPage = lazy(() => import('../pages/vendas/pdv/page'));
const OrcamentosPage = lazy(() => import('../pages/vendas/orcamentos/page'));
const NovoOrcamentoPage = lazy(() => import('../pages/vendas/orcamentos/novo/page'));
const DetalhesOrcamentoPage = lazy(() => import('../pages/vendas/orcamentos/detalhes/page'));
const EditarOrcamentoPage = lazy(() => import('../pages/vendas/orcamentos/editar/page'));
const CrmAtividadesPage = lazy(() => import('../pages/crm/atividades/page'));
const CrmOportunidadesPage = lazy(() => import('../pages/crm/oportunidades/page'));
const CrmAgendaPage = lazy(() => import('../pages/crm/agenda/page'));
const RelatoriosPage = lazy(() => import('../pages/relatorios/page'));
const UsuariosPage = lazy(() => import('../pages/usuarios/page'));
const ConfiguracoesEmpresaPage = lazy(() => import('../pages/configuracoes/empresa/page'));
const PlanosPage = lazy(() => import('../pages/planos/page'));
const OrdensServicoPage = lazy(() => import('../pages/servicos/ordens-servico/page'));
const NovaOrdemServicoPage = lazy(() => import('../pages/servicos/ordens-servico/nova/page'));
const DetalhesOrdemServicoPage = lazy(() => import('../pages/servicos/ordens-servico/detalhes/page'));
const ContratosPage = lazy(() => import('../pages/servicos/contratos/page'));
const ContratoDetalhePage = lazy(() => import('../pages/servicos/contratos/detalhes/page'));
const TiposServicoPage = lazy(() => import('../pages/configuracoes/tipos-servico/page'));
const AjudaPage = lazy(() => import('../pages/ajuda/page'));
const SuportePage = lazy(() => import('../pages/suporte/page'));
const FerramentasEtiquetasPage = lazy(() => import('../pages/ferramentas/etiquetas/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/precos',
    element: <PrecosPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/esqueci-senha',
    element: <EsqueciSenhaPage />,
  },
  {
    path: '/redefinir-senha',
    element: <RedefinirSenhaPage />,
  },
  {
    path: '/subscription/plans',
    element: <PlanSelectionPage />,
  },
  {
    path: '/termos',
    element: <LegalDocumentPage type="terms" />,
  },
  {
    path: '/privacidade',
    element: <LegalDocumentPage type="privacy" />,
  },
  {
    path: '/contrato-mensal',
    element: <LegalDocumentPage type="contract_monthly" />,
  },
  {
    path: '/contrato-anual',
    element: <LegalDocumentPage type="contract_annual" />,
  },
  {
    path: '/aceite-termos',
    element: <AceiteTermosPage />,
  },
  {
    path: '/app/admin/vouchers',
    element: <TrialVouchersPage />,
  },
  {
    path: '/app/admin/juridico',
    element: <AdminJuridicoPage />,
  },
  {
    path: '/app/admin/novidades',
    element: <AdminNovidadesPage />,
  },
  {
    path: '/app/admin/clientes',
    element: <AdminClientesPage />,
  },
  {
    path: '/app/admin/clientes/:id',
    element: <AdminClienteDetalhesPage />,
  },
  {
    path: '/app/admin/whatsapp',
    element: <AdminWhatsappPoolPage />,
  },
  {
    path: '/app/admin/planos',
    element: <AdminPlanosPage />,
  },
  {
    path: '/app/admin/alteracoes',
    element: <AdminAlteracoesPage />,
  },
  {
    path: '/app/admin/administradores',
    element: <AdminAdministradoresPage />,
  },
  { path: '/app/admin/comercial', element: <AdminComercialPage /> },
  { path: '/app/admin/comercial/representantes/:id', element: <AdminRepresentantePage /> },
  { path: '/app/admin/comercial/vendedores', element: <AdminVendedoresPage /> },
  { path: '/app/admin/comercial/clientes', element: <AdminComercialClientesPage /> },
  { path: '/app/admin/comercial/financeiro', element: <AdminComercialFinanceiroPage /> },

  // Portal Comercial (representantes e vendedores)
  { path: '/portal', element: <PortalDashboardPage /> },
  { path: '/portal/vouchers', element: <PortalVouchersPage /> },
  { path: '/portal/clientes', element: <PortalClientesPage /> },
  { path: '/portal/equipe', element: <PortalEquipePage /> },
  { path: '/portal/comissoes', element: <PortalComissoesPage /> },
  { path: '/portal/perfil', element: <PortalPerfilPage /> },

  {
    path: '/app/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/app/cadastros/clientes',
    element: <ClientesPage />,
  },
  {
    path: '/app/cadastros/clientes/:id',
    element: <ClienteCentralPage />,
  },
  {
    path: '/app/cadastros/fornecedores',
    element: <FornecedoresPage />,
  },
  {
    path: '/app/servicos/cadastro-servicos',
    element: <ServicosPage />,
  },
  {
    path: '/app/orcamentos/servicos',
    element: <ServicosPage />,
  },
  {
    path: '/app/estoque/produtos',
    element: <ProdutosPage />,
  },
  {
    path: '/app/estoque/entradas',
    element: <EntradasPage />,
  },
  {
    path: '/app/estoque/devolucao',
    element: <DevolucaoPage />,
  },
  {
    path: '/app/estoque/saidas',
    element: <SaidasPage />,
  },
  {
    path: '/app/estoque/dashboard',
    element: <EstoqueDashboardPage />,
  },
  {
    path: '/app/estoque/perdas',
    element: <PerdasEstoquePage />,
  },
  {
    path: '/app/estoque/ajustes',
    element: <AjustesEstoquePage />,
  },
  {
    path: '/app/estoque/producao',
    element: <ProducaoPage />,
  },
  {
    path: '/app/fiscal/notas',
    element: <NotasFiscaisPage />,
  },
  { path: '/app/fiscal/invoices', element: <InvoicesPage /> },
  { path: '/app/fiscal/exportacao', element: <ExportacaoRelatoriosPage /> },
  { path: '/app/fiscal/invoices/:id', element: <InvoiceDetalhePage /> },
  {
    path: '/app/fiscal/fechamento',
    element: <FechamentoFiscalPage />,
  },
  {
    path: '/app/financeiro/contas-pagar',
    element: <ContasPagarPage />,
  },
  {
    path: '/app/financeiro/contas-receber',
    element: <ContasReceberPage />,
  },
  {
    path: '/app/financeiro/fluxo-caixa',
    element: <FluxoCaixaPage />,
  },
  {
    path: '/app/financeiro/dashboard',
    element: <FinanceiroDashboardPage />,
  },
  {
    path: '/app/financeiro/contas-bancarias',
    element: <ContasBancariasPage />,
  },
  {
    path: '/app/financeiro/cobranca',
    element: <CobrancaPage />,
  },
  {
    path: '/app/financeiro/conciliacao',
    element: <ConciliacaoBancariaPage />,
  },
  {
    path: '/app/financeiro/perdas',
    element: <PerdasFinanceirasPage />,
  },
  {
    path: '/app/financeiro/dre',
    element: <DrePage />,
  },
  {
    path: '/app/vendas/vendas',
    element: <VendasPage />,
  },
  {
    path: '/app/ferramentas/etiquetas',
    element: <FerramentasEtiquetasPage />,
  },
  {
    path: '/app/vendas/expedicao',
    element: <ExpedicaoPage />,
  },
  {
    // Pipeline de Vendas foi substituído pela Expedição
    path: '/app/vendas/pipeline',
    element: <Navigate to="/app/vendas/expedicao" replace />,
  },
  {
    path: '/app/vendas/nova-venda',
    element: <NovaVendaPage />,
  },
  {
    path: '/app/vendas/nova-venda-b2b',
    element: <NovaVendaB2BPage />,
  },
  {
    path: '/app/vendas/orcamentos',
    element: <OrcamentosPage />,
  },
  {
    path: '/app/orcamentos/orcamentos',
    element: <OrcamentosPage />,
  },
  {
    path: '/app/vendas/orcamentos/novo',
    element: <NovoOrcamentoPage />,
  },
  {
    path: '/app/vendas/orcamentos/editar/:id',
    element: <EditarOrcamentoPage />,
  },
  {
    path: '/app/vendas/orcamentos/:id',
    element: <DetalhesOrcamentoPage />,
  },
  {
    path: '/app/pdv',
    element: <PDVPage />,
  },
  {
    path: '/app/crm/atividades',
    element: <CrmAtividadesPage />,
  },
  {
    path: '/app/crm/oportunidades',
    element: <CrmOportunidadesPage />,
  },
  {
    path: '/app/crm/agenda',
    element: <CrmAgendaPage />,
  },
  {
    path: '/app/relatorios',
    element: <RelatoriosPage />,
  },
  {
    path: '/app/usuarios',
    element: <UsuariosPage />,
  },
  {
    path: '/app/configuracoes/empresa',
    element: <ConfiguracoesEmpresaPage />,
  },
  {
    path: '/app/configuracoes/sistema',
    element: <ConfiguracoesEmpresaPage />,
  },
  {
    path: '/app/planos-e-assinatura',
    element: <PlanosPage />,
  },
  {
    path: '/app/ajuda',
    element: <AjudaPage />,
  },
  {
    path: '/app/suporte',
    element: <SuportePage />,
  },
  {
    path: '/app/servicos/ordens-servico',
    element: <OrdensServicoPage />,
  },
  {
    path: '/app/servicos/ordens-servico/nova',
    element: <NovaOrdemServicoPage />,
  },
  {
    path: '/app/servicos/ordens-servico/editar/:id',
    element: <NovaOrdemServicoPage />,
  },
  {
    path: '/app/servicos/ordens-servico/:id',
    element: <DetalhesOrdemServicoPage />,
  },
  { path: '/app/servicos/contratos', element: <ContratosPage /> },
  { path: '/app/servicos/contratos/:id', element: <ContratoDetalhePage /> },
  {
    path: '/app/servicos/tipos-servico',
    element: <TiposServicoPage />,
  },
  {
    path: '*',
    element: <LoginPage />, // Ou você pode criar um componente NotFoundPage e colocar aqui. Redirecionando para login por padrão.
  }
];

export default routes;
